import React from 'react';
import { LegendItem } from './LegendItem';
import { LegendContainer } from './style';
import colors from 'constants/colors';
import { OutOfServiceIcon } from 'assets/icons';

const Legend = ({desktop, mobile}) => {
  return (
    <LegendContainer desktop={desktop} mobile={mobile}>
      <LegendItem
        backgroundColor={colors.yellow}
        legendTitle="Room Dirty"
      />
      <LegendItem
        backgroundColor={colors.lightGreen}
        legendTitle="Room Clean"
      />
      <LegendItem
        backgroundColor={colors.blue}
        legendTitle="Inspected"
      />
      <LegendItem
        backgroundColor={colors.orange}
        legendTitle="Problem Found"
      />
      <LegendItem
        backgroundColor={colors.purple}
        legendTitle="Occupied"
      />
      <LegendItem
        backgroundColor={colors.red}
        legendTitle="Occupied (Stayover)"
      />
      <LegendItem
        iconComponent={<OutOfServiceIcon />}
        backgroundColor={colors.darkGrey}
        legendTitle="Out of Service"
      />
    </LegendContainer>
  );
};

export default Legend;
